// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2WMag","ranges":"BmiRanges_ranges__36KuW"};